import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { MoreVert } from "@mui/icons-material";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import { ReactComponent as EditIcon } from "./../../assets/images/icons/Google SVGs/edit.svg";
import { ReactComponent as PlaylistRemoveIcon } from "./../../assets/images/icons/Google SVGs/playlist_remove.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";

const DepartmentPlaceCard = (props) => {

  const { roles } = useSelector((state) => state.user);

  const [departmentBio, setDepartmentBio] = useState(props.departmentBio);
  const [departmentPhone, setDepartmentPhone] = useState(props.departmentPhone);

  return (
    <div>
      <div className="card background-bootstrap-gray-100 border-radius-8">
        <div className="card-body d-flex flex-row p-2 fs-14 fw-regular bg-transparent">
          <div className="col d-flex flex-column">
            <a
              className="color-bootstrap-gray-600 text-decoration-none"
              type="button"
              href={`/place?${"pl=" + props.id}`}
            >
              {props.placeTitle}
            </a>
            <div className="d-flex color-iso-gray-600 mt-2 fs-12">
              <span className="me-1">{props.departmentTitle}</span>
            </div>
          </div>
          {props.departmentId &&
            haveAccess(roles, "place_department_card_setting") && (
              <div className="col-auto d-flex align-items-center">
                <div className="dropdown me-1">
                  <IconButton
                    type="button"
                    id="dropdownMenuOffset"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    data-bs-offset="30,-45"
                  >
                    <MoreVert />
                  </IconButton>

                  <ul
                    className="dropdown-menu fit-dropdown w-fit ul-drop-shadow border-radius"
                    aria-labelledby="dropdownMenuOffset"
                  >
                    {haveAccess(
                      roles,
                      "place_department_card_setting_edit"
                    ) && (
                        <li
                          className="dropdown-item px-2 color-bootstrap-gray-600 text-decoration-none fs-12 w-100 d-flex align-items-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#detail-modal"
                          onClick={props.onEditModal}
                        >
                          <EditIcon width={18} className="me-1" />
                          ویرایش دپارتمان
                        </li>
                      )}
                    {haveAccess(roles, "place_department_card_setting_edit") &&
                      haveAccess(
                        roles,
                        "place_department_card_setting_remove"
                      ) && (
                        <li>
                          <hr className="dropdown-divider mx-2" />
                        </li>
                      )}
                    {haveAccess(
                      roles,
                      "place_department_card_setting_remove"
                    ) && (
                        <li
                          className="dropdown-item color-bootstrap-regular-danger fs-12 d-flex align-items-center px-2"
                          onClick={props.onRemoveDepartment}
                          type="button"
                        >
                          <PlaylistRemoveIcon width={18} className="me-1" />
                          حذف دپارتمان از این مکان
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            )}
        </div>
      </div>
      <div
        className="modal fade"
        id={`detail-modal${props.departmentId}`}
        tabIndex="-1"
        aria-labelledby={`detail-modal-label${props.departmentId}`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <span className="w-100">اطلاعات دپارتمان</span>
            </div>
            <div className="modal-body">
              {/* Detail inputs */}

              <div className="d-flex col mb-2 col-12">
                <input
                  className="form-control"
                  type="mobile"
                  placeholder="شماره تماس"
                  value={departmentPhone ? departmentPhone : ""}
                  onChange={(e) => {
                    setDepartmentPhone(e.target.value);
                  }}
                />
              </div>

              <div className="d-flex col my-2 col-12">
                <textarea
                  className="form-control"
                  placeholder="توضیحات دپارتمان (اختیاری)"
                  value={departmentBio ? departmentBio : ""}
                  onChange={(e) => {
                    setDepartmentBio(e.target.value);
                  }}
                />
              </div>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                onClick={props.onSuccess}
              >
                ویرایش دپارتمان {props.departmentTitle}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentPlaceCard;
